import React from "react"
import { useStore } from "@/store"

const TableHeader = ({ tables }) => {
  const { calendarDimensions } = useStore()

  return (
    <div
      style={{ height: calendarDimensions.tableLabelHeight, top: calendarDimensions.tableGroupLabelHeight }}
      className="flex w-full min-w-min sticky z-30"
    >
      {tables.map((table) => (
        <div
          key={table.id}
          className="flex text-center text-sm bg-white font-medium text-gray-800 border-0 border-r border-b border-solid border-gray-300 items-center justify-center"
          style={{ width: calendarDimensions.columnWidth }}
          data-testid={`panel-reservations-calendar-table-header-${table.id}`}
        >
          {table.name}
        </div>
      ))}
    </div>
  )
}

export default TableHeader
